export const CHART_SHAPE_OPACITY_TRANSITION = 'fill-opacity 400ms ease, stroke-opacity 400ms ease';
